import { createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f7764b34")

_pushScopeId("data-v-f7764b34")
const _hoisted_1 = { class: "modal-mask" }
const _hoisted_2 = { class: "modal-wrapper" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock(_Fragment, null, [
    ($data.showModal)
      ? (_openBlock(), _createBlock(_Transition, {
          key: 0,
          name: "modal",
          onClose: _cache[2] || (_cache[2] = ($event: any) => ($data.showModal = false))
        }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_1, [
              _createVNode("div", _hoisted_2, [
                _createVNode("img", {
                  src: $props.src,
                  class: "img-fluid",
                  style: {"cursor":"pointer"},
                  onClick: _cache[1] || (_cache[1] = ($event: any) => ($data.showModal = false))
                }, null, 8, ["src"])
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode("img", {
      src: $props.src,
      class: "img-fluid float-end",
      alt: "",
      onClick: _cache[3] || (_cache[3] = ($event: any) => ($data.showModal = true))
    }, null, 8, ["src"])
  ], 64))
})